import type { VehicleSearchFilters } from '../types/manualsearch.types';
import type { VinVrmSearchInput } from '../types/vinvrmsearch.types';

// Query key factory for consistent cache management
export const vehicleSearchKeys = {
    all: ['vehicleSearch'] as const,

    // Manual search keys
    filteredOptions: (filters?: VehicleSearchFilters) =>
        [...vehicleSearchKeys.all, 'filteredOptions', filters] as const,
    manualSearch: (filters: VehicleSearchFilters) =>
        [...vehicleSearchKeys.all, 'manualSearch', filters] as const,

    // VIN/VRM search keys
    vinVrmSearch: (query: VinVrmSearchInput) =>
        [...vehicleSearchKeys.all, 'vinVrmSearch', query] as const,

    // Bulk by-ID lookup keys
    makesByIds: (ids: string[]) => [...vehicleSearchKeys.all, 'makes', 'byIds', ids] as const,
    modelsByIds: (ids: string[]) => [...vehicleSearchKeys.all, 'models', 'byIds', ids] as const,
    derivativesByIds: (ids: string[]) => [...vehicleSearchKeys.all, 'derivatives', 'byIds', ids] as const,
    transmissionsByIds: (ids: string[]) => [...vehicleSearchKeys.all, 'transmissions', 'byIds', ids] as const,
    fuelTypesByIds: (ids: string[]) => [...vehicleSearchKeys.all, 'fuelTypes', 'byIds', ids] as const,

    // Full active reference lists
    fuelTypes: () => [...vehicleSearchKeys.all, 'fuelTypes', 'all'] as const,
    transmissions: () => [...vehicleSearchKeys.all, 'transmissions', 'all'] as const,
} as const;

/** A sibling factory, deliberately not folded into vehicleSearchKeys: a different
 *  resource with a different invalidation lifetime from a search result. */
export const vehicleRegistrationKeys = {
    all: ['vehicleRegistration'] as const,
    detail: (vehicleId: string) => [...vehicleRegistrationKeys.all, vehicleId] as const,
    mileage: (vehicleId: string) => [...vehicleRegistrationKeys.detail(vehicleId), 'mileage'] as const,
    amendments: (vehicleId: string) => [...vehicleRegistrationKeys.detail(vehicleId), 'amendments'] as const,
    amendmentsPage: (vehicleId: string, page: number, perPage: number, type?: string) =>
        [...vehicleRegistrationKeys.amendments(vehicleId), 'page', page, perPage, type ?? 'all'] as const,
} as const;
